{
  "enum": {
    "IxcClearingV1ClosingPositionStatus": {
      "OPEN": "Open",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcClearingV1ClosingPositionQueryServiceClosingPositionListFilterableFields": {
      "assetId": "Asset",
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Category",
            "type": {
              "!type": "Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity: Can Buy",
                  "canEnterFractions": "Equity: Can Enter Fractions",
                  "canSell": "Equity: Can Sell"
                },
                "cusip": "Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market: Classification",
                "controls": {
                  "canBuy": "Money Market: Can Buy",
                  "canEnterFractions": "Money Market: Can Enter Fractions",
                  "canSell": "Money Market: Can Sell"
                },
                "cusip": "Money Market CUSIP",
                "navType": "Money Market: NAV Type"
              }
            }
          },
          "status": "Status"
        }
      },
      "date": "Date",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcClearingV1ClosingPositionEventType": {
      "dtcbal": "DTC Bal",
      "memoSegBalance": "Memo Seg Balance",
      "portfolioTotals": "Portfolio Totals"
    }
  },
  "searchEnum": {
    "IxcClearingV1ClosingPositionQueryServiceClosingPositionListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity Name",
                "symbol": {
                  "base": "Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Money Market Name",
                "symbol": {
                  "base": "Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcClearingV1ClosingPositionQueryServiceClosingPositionListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Created At",
            "updatedAt": "Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}